{
  "ru": {
    "charter": {
      "charter": "Чартер",
      "charterFlight": "Чартерный рейс",
      "whatIsCharterFlight": "Что такое чартерные рейсы?",
      "howTheyWork": "Как работают чартерные рейсы",
      "flight": "Электронный билет",
      "afterPayment": "После оплаты вы получите маршрутную квитанцию — она подтверждает вашу бронь.",
      "flightTime": "Время и аэропорт вылета",
      "charterChangeTime": "Иногда чартеры меняют расписание или аэропорт. Мы заранее уведомим, если что-то изменится.",
      "registration": "Регистрация",
      "onlineRegistration": "Онлайн-регистрация на чартерные рейсы может быть недоступна. \n Пожалуйста, приезжайте в аэропорт чуть раньше, чтобы пройти регистрацию у стойки авиакомпании.",
      "refundExchange": "Возврат и обмен",
      "cannotRefundExchange": "Чартерные тарифы позволяют экономить на перелете, но они менее гибкие: обмен билетов невозможен, а возврат осуществляется с ограничениями по правилам перевозчика",
      "refundExchangeRules": "Правила обмена и возврата",
      "readConditions": "Читать условия"
    }
  },
  "kk": {
    "charter": {
      "charter": "Чартер",
      "charterFlight": "Чартер рейс",
      "whatIsCharterFlight": "Чартер рейс деген не?",
      "howTheyWork": "Чартер рейсіне қатысты бар ақпарат",
      "flight": "Электрондық билет",
      "afterPayment": "Билеттің ақысын төлегеннен кейін маршрут түбіртегін аласыз. Ол түбіртек броніңіз жарамды екеніне дәлел болады.",
      "flightTime": "Ұшып шығатын уақыт пен әуежай",
      "charterChangeTime": "Кейде чартерлер ұшатын уақыт я әуежай ауысып кетуі мүмкін. Өзгеріс болса, сізге дереу хабарлаймыз.",
      "registration": "Тіркеу",
      "onlineRegistration": "Чартер рейстерге онлайн тіркелу мүмкіндігі болмауы мүмкін. \n Сондықтан әуежайға ертерек барып тұрыңыз. Әуе компаниясының тіркеу үстелінің басына барып тіркелуге біраз уақыт кетеді.",
      "refundExchange": "Қайтару мен ауыстыру",
      "cannotRefundExchange": "Чартерлік тарифтер жұмысын үнемдеуге мүмкіндік береді, бірақ олар еріктірек емес: билеттерді ауыстыру мүмкін емес, ал қайтару өткізгіштің ережелеріне сәйкес жүзеге асырылады",
      "refundExchangeRules": "Қайтару мен ауыстыру ережелері",
      "readConditions": "Шарттарын оқу"
    }
  },
  "en": {
    "charter": {
      "charter": "Charter",
      "charterFlight": "Charter flight",
      "whatIsCharterFlight": "What is charter flights?",
      "howTheyWork": "How charter flights work",
      "flight": "Electronic ticket",
      "afterPayment": "After payment, you will receive a routing receipt — it confirms your booking.",
      "flightTime": "Flight time and departure airport",
      "charterChangeTime": "Sometimes charter flights change the schedule or airport. We will notify you in advance if something changes.",
      "registration": "Registration",
      "onlineRegistration": "Online registration for charter flights may not be available. \n Please arrive at the airport a little earlier to register at the airline's counter.",
      "refundExchange": "Refund and exchange",
      "cannotRefundExchange": "Charter fares allow you to save on the flight, but they are less flexible: ticket exchanges are not possible, and refunds are subject to the airline's rules",
      "refundExchangeRules": "Refund and exchange rules",
      "readConditions": "Read conditions"
    }
  }
}
